<template>
  <v-card outlined tile class="ma-3 pa-0 align-start">
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Наименование</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="EI_NAME" dense :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Ед. ОКЕИ</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="OKEI" dense readonly >
          <template v-slot:append v-if="mode=='editor'">
            <v-icon small @click="callSelectOKEI"> mdi-plus-circle-multiple-outline </v-icon>
          </template>
        </v-text-field>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Код</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="EI_CODE" dense :readonly="mode=='viewer'"  maxlength="5" hint="5 символов" persistent-hint/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullMode">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Базовая единица</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="BASE" dense readonly/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullMode">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Множитель</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="MULTIPLIER" dense :readonly="mode=='viewer'" type="number"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullMode">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Показатель</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="MULTIPLIER_INDICATOR" dense :readonly="mode=='viewer'" type="number"/>
      </v-card>
    </v-card>
    <ref-o-k-e-i-select-dialog :o-k-e-i="OKEI" v-model="showSelectOKEI" @onOKEIChanged="setOKEI"></ref-o-k-e-i-select-dialog>
  </v-card>
</template>

<script>
import RefOKEISelectDialog from '@/components/modules/references/dialogs/refOKEISelectDialog'
export default {
  name: 'refMUCard',
  components: { RefOKEISelectDialog },
  props: ['MU', 'mode', 'fullMode'],
  data () {
    return {
      showSelectOKEI: false
    }
  },
  computed: {
    EI_NAME: {
      get () {
        return this.MU ? this.MU.EI_NAME : ''
      },
      set (val) {
        this.$emit('onMUUpdate', { EI_NAME: val })
      }
    },
    EI_CODE: {
      get: function () {
        return this.MU ? this.MU.EI_CODE : ''
      },
      set (val) {
        this.$emit('onMUUpdate', { EI_CODE: val })
      }
    },
    BASE: {
      get: function () {
        return this.MU ? this.MU.BASIC ? this.MU.BASIC.EI_NAME : 'нет' : 'нет'
      },
      set (val) {
        this.$emit('onMUUpdate', { BASIC: val })
      }
    },
    MULTIPLIER: {
      get: function () {
        return this.MU ? this.MU.MULTIPLIER || 1 : 1
      },
      set (val) {
        this.$emit('onMUUpdate', { MULTIPLIER: val })
      }
    },
    MULTIPLIER_INDICATOR: {
      get: function () {
        return this.MU ? this.MU.MULTIPLIER_INDICATOR || 1 : 1
      },
      set (val) {
        this.$emit('onMUUpdate', { MULTIPLIER_INDICATOR: val })
      }
    },
    OKEI: {
      get: function () {
        const retVal = this.MU ? this.MU.OKEI ? this.MU.OKEI.OK_NAME : 'нет' : 'нет'
        console.log('Dynamic property OKEI getting ', retVal, ' local MU is ', this.MU)
        return retVal
      },
      set (val) {
        console.log('Dynamic property OKEI setting ', val)
        this.$emit('onMUUpdate', { OKEI: val })
      }
    }
  },
  methods: {
    callSelectOKEI () {
      console.log('clicked')
      this.showSelectOKEI = true
    },
    setOKEI (val) {
      console.log('Setting OKEI to ', val)
      this.OKEI = val
    }
  },
  mounted () {
    console.log('refMUCard mounted in mode ', this.mode, ' with MU ', this.MU)
  }
}
</script>

<style scoped>

</style>
